import React from 'react';
import ReactDOM from 'react-dom';
import FascinatingFindsWizard from './FascinatingFindsWizard';

const contextEl = document.getElementById('ff-context');
const context = contextEl ? JSON.parse(contextEl.textContent) : null;
const mountEl = document.getElementById('ff-content');

if (context && mountEl) {
  ReactDOM.render(<FascinatingFindsWizard context={context} />, mountEl);
}
